import { RegisterOptions } from 'react-hook-form'
import { FormValues } from '.'

export const errorMessage = "Please tell us why you can't provide this."

export const additionalDetailsValidationRules: RegisterOptions<
  FormValues,
  'additionalDetails'
> = {
  required: errorMessage,
  minLength: {
    value: 1,
    message: errorMessage,
  },
  validate: val => val.trim().length > 0 || errorMessage,
}
